/* eslint-disable import/prefer-default-export */
import icon from '../assets/krackeler-favicon.ico';

export const krackelerConfig = {
  title: 'Krackeler',
  catalog: 'partner',
  partner: 'krackeler',
  origin: 'krackeler.com',
  host: 'chairs.krackeler.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/krackeler-logo.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/krackeler-logo.png',
  buildAChair: 'ecom',
  businessInfo: 'Krackeler Scientific Inc. | 57 Broadway | Albany, NY 12202',
  headerTheme: '#000000',
  secondaryTheme: '#AAD038',
  footerTheme: '#F0F0F0',
  headerTextColor: '#FFFFFF',
  footerTextColor: '#000000',
  buttonTextColor: '#FFFFFF',
  phone: '1-800-334-7725',
  footerLogoStyle: {
    maxHeight: 'fit-content',
    maxWidth: 'fit-content',
    paddingTop: '32px',
  },
  extraAttributes: {
    trackId: 'G-1PPSHZSFCW',
    icon,
  },
};
